import { Button, Divider, Icon, Modal, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import * as _ from 'lodash'
import ProgressGuideView from '../../../components/ProgressGuideView'
import { Sticker } from '../../../types'
import TagSelectForm from '../../tag/TagSelectForm'
import StickerWrapper from '../../../components/sticker/StickerWrapper'
import { notiFormForError } from '../../../components/notificationForm'
import StickerTagInfo from '../../../components/sticker/StickerTagInfo'
import { useUserWithRedirect } from '../../../hooks/user/useUserWithRedirect'
import { useEveryStickerCategory } from '../../../hooks/reactQuery/useEveryStickerCategory'

import { usePackageInfo } from '../../../hooks/reactQuery/usePackage'
import { usePutStickerCategory } from '../../../hooks/reactQuery/useTag'
import StickerListForTagSelect from '../../tag/StickerListForTagSelect'

import '../../../styles/tagSelect.css'
import { useIsMutating } from 'react-query'

const messages = defineMessages({
  stickerDelete: {
    id: 'progressPkg.sticker.delete',
    defaultMessage: 'Are you sure you want to delete it? 🤔',
  },
  noLangSelectedMessage: {
    id: 'ErrorMessage.noLanguageSelected',
    defaultMessage: 'No language selected.\n Please choose other language.',
  },
  noStickersInPkg: {
    id: 'ErrorMessage.noStickersInPkg',
    defaultMessage:
      'No stickers have been added.\n Please add at least one sticker.',
  },
  noLangPlusPack: {
    id: 'ErrorMessage.noLangPlusPack',
    defaultMessage: 'Please select a language for Plus Pack.😢',
  },
  needSaveTagBeforeMoveOtherSticker: {
    id: 'SelectTag.modal.stickerChange.beforeSave',
  },
})

const defineStickerBorderColor = (sticker: Sticker) => {
  // 반력된 스티커 이면
  if (sticker.stickerInspectionData) {
    if (sticker.stickerInspectionData.needTagEditing) {
      return 'yellow'
    } else if (sticker.stickerInspectionData.isPassed) {
      return 'purple'
    }
  }
  //태깅을 선택했으면
  if (
    sticker.emojiCategories &&
    sticker.emojiCategories.length > 0 &&
    sticker.textLang
  ) {
    return 'green'
  }
  return 'red'
}

export default function SelectTagLayout() {
  const { packageId } = useParams<{ packageId: string }>()
  const isMutatingPackage = useIsMutating(packageId) > 0
  const user = useUserWithRedirect()
  const {
    data: packageAndSticker,
    error,
    isLoading: packageInfoLoading,
  } = usePackageInfo(packageId, user?.sessionToken)
  const { data: everyStickerCategory, isLoading: stickerCategoryLoading } =
    useEveryStickerCategory()

  const mutationStickerTagUpdate = usePutStickerCategory(packageId)
  const intl = useIntl()

  // modal 에서 선택될 스티커 변결될 스티커
  const [selectedSticker, setSelectedSticker] = useState<null | Sticker>(null)

  const [tagSelectModalVisibel, setTagSelectModalVisibel] = useState(false)
  const openModal = (sticker: Sticker) => {
    setSelectedSticker({
      ...sticker,
      textLang: sticker.textLang ? sticker.textLang : 'IMAGE_ONLY',
    })

    setTagSelectModalVisibel(true)
  }
  const changeSelectedSticker = (sticker: Sticker) => {
    if (!selectedSticker) {
      return setSelectedSticker(sticker)
    }
    if (selectedSticker.objectId === sticker.objectId) return

    const stickerOrigin = packageAndSticker?.emoticons.find(
      (emoticon) => emoticon.objectId === selectedSticker.objectId,
    )
    if (stickerOrigin) {
      console.log(
        selectedSticker.emojiCategories,
        stickerOrigin.emojiCategories,
      )
      console.log(selectedSticker.textLang, stickerOrigin.textLang)
      if (
        !_.isEqual(
          selectedSticker.emojiCategories,
          stickerOrigin.emojiCategories,
        ) ||
        !_.isEqual(selectedSticker.textLang, stickerOrigin.textLang)
      ) {
        notiFormForError(
          intl.locale,
          intl.formatMessage(messages.needSaveTagBeforeMoveOtherSticker),
        )
      } else {
        return setSelectedSticker(sticker)
      }
    }
    // 현재 선택된 이미지의 카테고리나 태그가 변경됬는데 다른 이미지로 저장하지 않고 넘어가려고 한다면
  }
  const isTagChanged = () => {
    if (
      !packageAndSticker ||
      !packageAndSticker.emoticons ||
      !selectedSticker
    ) {
      return false
    }
    const originSticker = packageAndSticker.emoticons.find(
      (emoticon) => emoticon.objectId === selectedSticker.objectId,
    )
    if (!originSticker) {
      return false
    }
    if (
      !_.isEqual(
        selectedSticker.emojiCategories,
        originSticker.emojiCategories,
      ) ||
      !_.isEqual(selectedSticker.textLang, originSticker.textLang)
    ) {
      notiFormForError(
        intl.locale,
        intl.formatMessage(messages.needSaveTagBeforeMoveOtherSticker),
      )
    }
  }
  const handleOk = () => {
    if (isMutatingPackage) return
    if (selectedSticker && user) {
      mutationStickerTagUpdate.mutate({
        sessionToken: user.sessionToken,
        stickerOid: selectedSticker.objectId,
        textLang: selectedSticker.textLang,
        emojiCategories: selectedSticker.emojiCategories,
      })
    }
    setTagSelectModalVisibel(false)
  }

  useEffect(() => {
    if (
      packageAndSticker &&
      packageAndSticker?.emoticons &&
      packageAndSticker.emoticons.length === 0
    ) {
      notiFormForError(
        intl.locale,
        intl.formatMessage(messages.noStickersInPkg),
      )
    }
  }, [packageAndSticker, intl])

  if (!everyStickerCategory || !packageAndSticker) {
    return <></>
  }

  const packageInfo = packageAndSticker
  const stickerList = packageAndSticker.emoticons
    ? packageAndSticker.emoticons
    : []
  const isEmptyTaggingInfo = (sticker: Sticker) => {
    const needAddEmojiCategory =
      !sticker.emojiCategories || sticker.emojiCategories.length === 0

    return needAddEmojiCategory && !sticker.textLang
  }

  return (
    <>
      <ProgressGuideView step="select-tag" language={intl.locale} />
      <div className="sticker-upload-pack-box">
        <Divider style={{ margin: '0px' }} />
        <div className="sticker-upload-pack-info-box">
          <div className="sticker-upload-pack-label">
            <div className="sticker-upload-pack-label-text">
              <FormattedMessage
                id="Upload.packType"
                defaultMessage="Pack Type"
              />
            </div>
          </div>
          <div className="sticker-upload-pack-input">
            <div className="sticker-upload-pack-label-text">
              {packageInfo?.packType ? (
                <div className={`pack-type-badge-${packageInfo?.packType}`}>
                  <span>
                    <FormattedMessage
                      id={`Upload.packType.${packageInfo?.packType}`}
                      defaultMessage="Plus Pack"
                    />
                  </span>
                </div>
              ) : (
                <FormattedMessage
                  id={'Upload.PkgCreation.createPack.packType.undefined'}
                  defaultMessage="No type"
                />
              )}
              {packageInfo?.movingStatus && (
                <FormattedMessage
                  id={`Upload.movingStatus.${packageInfo?.movingStatus}`}
                  defaultMessage=" "
                />
              )}
            </div>
          </div>
        </div>
        <Divider style={{ margin: '0px' }} />
      </div>
      <div className="sticker-list-with-tag">
        {stickerList.map((sticker, i) => (
          <div key={i.toString() + sticker.objectId}>
            <div>{`${i + 1 < 10 ? '0' + (i + 1) : i + 1}`}</div>
            <div key={sticker.objectId} className="sticker-withtag-wrapper">
              <StickerWrapper
                key={sticker.objectId}
                sticker={sticker}
                imgBorder={defineStickerBorderColor(sticker)}
              >
                {!sticker.stickerInspectionData?.isPassed && (
                  <Icon
                    onClick={() => openModal(sticker)}
                    type="smile-o"
                    className="hover-icon"
                  />
                )}
              </StickerWrapper>

              <div className="tag-list">
                {isEmptyTaggingInfo(sticker) ? (
                  <div className="align-center">
                    <Icon
                      type="plus-circle"
                      theme="filled"
                      style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.38)' }}
                    />
                    <div className="sticker-tag-wrapper-tag-add-font">
                      <FormattedMessage id="SelectTag.guide.addTag" />
                    </div>
                  </div>
                ) : (
                  <StickerTagInfo
                    textLang={sticker.textLang}
                    emojiCategories={sticker.emojiCategories}
                  />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* 태그 선택 모달 */}
      <Modal
        className="tag-select-modal"
        onCancel={() => {
          setTagSelectModalVisibel(false)
        }}
        width="1040px"
        visible={tagSelectModalVisibel}
        footer={null}
      >
        {selectedSticker && packageInfo && (
          <>
            <TagSelectForm
              everyStickerCategory={everyStickerCategory}
              packageAndSticker={packageAndSticker}
              selectedSticker={selectedSticker}
              setSelectedSticker={setSelectedSticker}
            />
            <div className="tag-select-modal-button-container">
              {/* <Button
                size="large"
                style={{ minWidth: 100, fontSize: 16, margin: '25px 19px' }}
                onClick={handleOk}
              >
                <FormattedMessage
                  id={'SelectTag.modal.resetBtn'}
                  defaultMessage={'Reset'}
                />
              </Button> */}
              <Button
                key="submit"
                type="primary"
                size="large"
                className="btn-style-primary"
                style={{ minWidth: 100, fontSize: 16, margin: '25px 19px' }}
                onClick={handleOk}
              >
                <FormattedMessage
                  id={'SelectTag.modal.btn'}
                  defaultMessage={'Save'}
                />
              </Button>
            </div>
            {/* 선택한 태그들을 바꿀수 있는태그 지금은 이걸 추가해도 ux 에 더 좋을지 의문임*/}
            {/* <StickerListForTagSelect
                stickerList={stickerList}
                clickHandler={changeSelectedSticker}
              /> */}
          </>
        )}
      </Modal>
    </>
  )
}
